module.exports = __webpack_public_path__ + "eceddf474df95d8d4a7e316668c3be85.ttf";


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-widgets/lib/fonts/rw-widgets.ttf?v=4.1.0
 ** module id = 1140
 ** module chunks = 0
 **/